import { render, staticRenderFns } from "./sandbox.vue?vue&type=template&id=4a87a131&scoped=true"
import script from "./sandbox.vue?vue&type=script&lang=js"
export * from "./sandbox.vue?vue&type=script&lang=js"
import style0 from "./sandbox.vue?vue&type=style&index=0&id=4a87a131&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87a131",
  null
  
)

export default component.exports